import { Button } from "@/components/ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/ui/dialog";
import { t } from "i18next";
import { CreateAccountState } from "@/hooks/accounts/useCreateAccountStore";

interface ResetFormDialogProps {
	store: CreateAccountState;
	open: boolean;
	onOpenChange: (open: boolean) => void;
}

export const ResetFormDialog = ({
	store,
	open,
	onOpenChange,
}: ResetFormDialogProps) => {
	const handleCancel = () => {
		onOpenChange(false);
	};

	const handleReset = () => {
		store.reset();
		onOpenChange(false);
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{t("admin.dialog.reset-form.title")}</DialogTitle>
					<DialogDescription>
						{t("admin.dialog.reset-form.description")}
					</DialogDescription>
					<DialogFooter className="pt-8">
						<Button variant="outline" onClick={handleCancel}>
							{t("admin.button.cancel")}
						</Button>
						<Button variant="destructive" onClick={handleReset}>
							{t("admin.button.reset-now")}
						</Button>
					</DialogFooter>
				</DialogHeader>
			</DialogContent>
		</Dialog>
	);
};
